import IMask from 'imask'
import { defaultMemoize } from 'reselect'

const MAX_NUMBER = 999_999_999

type CreateNumberMaskProps = {
  min: number
  max?: number
  signed?: boolean
}

const getNumbersLocale = defaultMemoize(() => {
  try {
    const [, thousandsSeparator, , radix] = Intl.NumberFormat().formatToParts(1000.1)
    return {
      thousandsSeparator: thousandsSeparator.value,
      radix: radix.value,
    }
  } catch (e) {}

  return {
    thousandsSeparator: ',',
    radix: '.',
  }
})


function createNumberMask ({ min, max = MAX_NUMBER, signed = false }: CreateNumberMaskProps) {
  return {
    ...getNumbersLocale(),
    mask: Number,
    signed,
    min,
    max,
  }
}

type CreateCurrencyMaskProps =
  & CreateNumberMaskProps
  & {

  }
export function createCurrencyMask (props: CreateCurrencyMaskProps) {
  return {
    mask: '$num',
    blocks: {
      num: createNumberMask(props),
    },
  }
}

type CreatePercentMaskProps =
  & CreateNumberMaskProps
  & {

  }
function createPercentMask (props: CreatePercentMaskProps) {
  return {
    mask: 'num%',
    lazy: false,
    blocks: {
      num: {
        ...createNumberMask(props),
        padFractionalZeros: true,
      },
    },
  }
}
function createPercentIntegerMask (props: CreatePercentMaskProps) {
  return {
    mask: 'num%',
    lazy: false,
    blocks: {
      num: {
        ...createNumberMask(props),
        padFractionalZeros: false,
      },
    },
  }
}

export const maskNumberFromZero = createNumberMask({ min: 0 })
export const maskNumberPositive = createNumberMask({ min: 1 })
export const maskNumberFromZeroTo1200 = createNumberMask({ min: 0, max: 1200 })
export const maskNumberPositiveTo1200 = createNumberMask({ min: 1, max: 1200 })

export const maskCurrencyFromZero = createCurrencyMask({ min: 0 })
export const maskCurrencyFromZeroWithCents = {
  mask: '$num',
  lazy: false,
  blocks: {
    num: {
      ...createNumberMask({ min: 0 }),
      padFractionalZeros: true,
    },
  },
} as const
export const maskCurrencyPositive = createCurrencyMask({ min: 1 })

export const maskPercentSigned = createPercentMask({ min: -100, max: 100, signed: true })
export const maskPercentFromZero = createPercentMask({ min: 0, max: 100 })
export const maskPercentIntegerZero = createPercentIntegerMask({ min: 0, max: 100 })
export const maskPercentNegative = createPercentMask({ min: -100, max: 0 })

export const maskPercentNeg30To50 = createPercentMask({ min: -30, max: 50, signed: true })
export const maskPercentNeg10To20 = createPercentMask({ min: -10, max: 20, signed: true })
export const maskPercentNeg20To20 = createPercentMask({ min: -20, max: 20, signed: true })


export const maskUSZipCode = {
  mask: '00000',
}


export const maskCreditCard = {
  mask: '0000 0000 0000 0000',
}

export const maskMonth = {
  mask: IMask.MaskedRange,
  from: 1,
  to: 12,
  maxLength: 2,
}

export const maskYearFromCurrent = {
  mask: IMask.MaskedRange,
  from: new Date().getFullYear(),
  to: new Date().getFullYear() + 1000,
}

